import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3489cd3c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "errPage-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "text-jumbo text-ginormous"
}, "Oops!", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "你没有权限去该页面", -1));
const _hoisted_4 = {
  class: "list-unstyled"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "或者你可以去:", -1));
const _hoisted_6 = {
  class: "link-type"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
import gif401 from '@/assets/401_images/401.gif';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: '401',
  setup(__props) {
    const errGif = ref(gif401 + '?' + +new Date());
    const ewizardClap = ref('');
    const dialogVisible = ref(false);
    const route = useRoute();
    const router = useRouter();
    const back = () => {
      if (route.query.noGoBack) {
        router.push({
          path: '/'
        });
      } else {
        router.go(-1);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
        icon: "el-icon-arrow-left",
        class: "pan-back-btn",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(" 返回 ")]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_hoisted_2, _hoisted_3, _createElementVNode("ul", _hoisted_4, [_hoisted_5, _createElementVNode("li", _hoisted_6, [_createVNode(_component_router_link, {
            to: "/"
          }, {
            default: _withCtx(() => [_createTextVNode(" 回首页 ")]),
            _: 1
          })]), _createElementVNode("li", null, [_createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => dialogVisible.value = true, ["prevent"]))
          }, "点我看图")])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: errGif.value,
            width: "313",
            height: "428",
            alt: "Girl has dropped her ice cream."
          }, null, 8, _hoisted_7)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event),
        title: "随便看",
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: ewizardClap.value,
          class: "pan-img"
        }, null, 8, _hoisted_8)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};